/* Jade v2 · story shell (section 1), deferred after jade-v2-core.js. Vanilla: one passive scroll listener and one rAF. Every position
   is measured on build (load, fonts, width change, the main column or the chrome above it resizing); a frame only compares scrollY
   with cached numbers. Port of v5's d-shell.js, native scrolling.
   Owns: the Dhofar stage (cross-dissolves in the gaps between text blocks, the warm-up a screen ahead), the gold
   spine and its ring, and the CHOOSE row following the tier (the sticky bar is pdp-atc.js's).
   NATIVE (round 2): where CSS.supports('animation-timeline: scroll()'), the dissolves, pushes and spine growth are CSS scroll-driven
   animations (jade-v2-story.css, html.d-sda); this file writes their scroll ranges once per build and nothing per frame inside the
   sticky stage (main-thread writes racing async scrolling made it shiver on iPhone). The --p/opacity writes below are the fallback.
   QA hooks (v5 tools): window.__dFlow, __dOpac, __dSpine, __dShell (the watchdog's flag). */
(function () {
  'use strict';
  var w = window, d = document, h = d.documentElement, S = w.SSD;
  var $ = function (s, c) { return (c || d).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); };
  var story = $('#d-story');
  if (!story) return;
  /* no core: the static page at once */
  if (!S) { h.classList.remove('d-stage-on'); return; }
  w.__dShell = true;
  if (S.reduced) h.classList.remove('d-stage-on');
  var stageOn = h.classList.contains('d-stage-on');

  var root = story.closest('.jv2') || story;
  var scenes = $$('.d-scene', story), win = $('#d-green-win'), winB = $('#d-green-b'), labs = $$('.d-green-lab'), labsO = -1;
  var vh = w.innerHeight, vw = w.innerWidth, phone = vw < 900, svh = vh;
  var LIFT_F = 0.3;
  var WARM = 0.9, K = null, SP = null, drawn = 0, ni = 0, ringOn = false, lastY = -1, ticking = false, armed = false, storyTop = -1, spY = 0;
  var SD = !!(w.CSS && CSS.supports && CSS.supports('animation-timeline:scroll()') && CSS.supports('animation-range:0px 1px'));
  var SDA = SD && stageOn, SDS = SD && !S.reduced;
  /* write a property only when it changes (a same-value write is still a mutation) */
  function setV(el, n, v) { v = Math.round(v * 10) / 10 + 'px'; el._cv = el._cv || {}; if (el._cv[n] !== v) { el._cv[n] = v; el.style.setProperty(n, v); } }

  function top(el) { return el.getBoundingClientRect().top + w.scrollY; }
  /* where a block's WORDS begin: the green's block opens with a --lead of empty padding, so time its dissolve from its heading (flow audit,
     4 Oct: its picture led its words by 0.53 screen on phones and 0.67 on laptops, against 0.27-0.37 for the other beats) */
  function wtop(el) { return top(el.firstElementChild || el); }
  function bot(el) { return el.getBoundingClientRect().bottom + w.scrollY; }
  /* layout top, ignoring transforms (a .d-rv block is drawn 16px low and scaled until it is revealed) */
  function flowTop(el) { var t = 0; while (el) { t += el.offsetTop; el = el.offsetParent; } return t; }
  function ss(t) { return t <= 0 ? 0 : t >= 1 ? 1 : t * t * (3 - 2 * t); }
  function clamp01(t) { return t < 0 ? 0 : t > 1 ? 1 : t; }
  /* svh and the spine's x from the real CSS */
  function measureSvh() {
    var p = d.createElement('div'); p.style.cssText = 'position:absolute;visibility:hidden;height:calc(var(--sv,1svh)*100);width:var(--spine-x)';
    root.appendChild(p); svh = p.offsetHeight || w.innerHeight; var sx = p.offsetWidth; root.removeChild(p); return sx;
  }

  /* the stage: a dissolve is centred where the text above has cleared the middle band and the text below has not entered it.
     Positions come from the real DOM. Block 0 is the hero's buy card (the lineage line left on 4 Oct: the hero hands straight to
     the origin). Phones: S0 -> S1 happens under the hero's ivory sheet, which starts where its top padding ends and ends in a 16svh
     fade; where the sheet is shorter than a screen, the tree dissolves in just after the sheet has covered the hero picture, under
     the sheet's foot (ivory, S0's own ground there, to the sharp tree: never through anything darker). */
  function buildStage() {
    var hw = 0.13 * vh, T = [];
    function wOf(k) { var sc = scenes[k + 1], v = sc ? parseFloat(sc.getAttribute('data-d-dw')) : 0; return v > 0 ? v * vh : hw; } /* half-width of dissolve k, from data-d-dw on the incoming figure */
    /* block k introduces scene k, in DOM order */
    var blocks = [$('.d-buy', story)].concat($$('.d-sc .d-sc-txt', story));
    /* the green (last gap) dissolves in the middle of its long room, so the green picture arrives alone and holds before its words come
       in like an introduction (Sho, 4 Oct: that pause "felt much better"; the in-step timing tried that day was reverted). The pause is
       held near its original length (~0.55 screen phones, ~0.65 laptops) whatever the copy above it measures. */
    function gap(a, b, k) { var ca = bot(a) - 0.25 * vh, cb = top(b) - 0.75 * vh, c = (ca + cb) / 2; if (k === blocks.length - 2) c = Math.max(c, wtop(b) - (phone ? 1.07 : 1.19) * vh); return { c: c, w: wOf(k), room: cb - ca }; }
    var sheet = null;
    if (phone) {
      var hero = $('.d-hero', story);
      var pad = parseFloat(w.getComputedStyle(hero).paddingTop) || 0.48 * svh;
      var a = top(hero) + pad, b = bot(hero) - 0.16 * svh;
      sheet = { a: a, b: b };
      var lo = a, hi = b - vh;
      /* uncovered: a short dissolve (a long one reads as grey fog over the ivory), done before the origin's words reach the middle band */
      var wq = Math.max(hw * 0.6, Math.min(hw, (wtop(blocks[1]) - 0.75 * vh - lo) / 2));
      T.push(hi > lo ? { c: (lo + hi) / 2, w: Math.max(8, Math.min(hw, (hi - lo) / 2)), covered: true } : { c: lo + wq, w: wq, covered: false });
    } else T.push(gap(blocks[0], blocks[1], 0));
    for (var k = 1; k < blocks.length - 1; k++) T.push(gap(blocks[k], blocks[k + 1], k));
    var lastBlock = blocks[blocks.length - 1], TL = T[T.length - 1];
    var gt = top(lastBlock), W = { a: gt - 0.92 * vh, b: gt - 0.36 * vh };
    W.a = Math.max(W.a, TL.c + TL.w + 0.04 * vh); if (W.b < W.a + 0.3 * vh) W.b = W.a + 0.3 * vh;
    /* the wipe labels leave before the hand-off */
    var ho = top($('.d-handoff', story)) - vh + (phone ? 110 : 60);
    K = { life: T.map(function (t, i) { return { a: i ? T[i - 1].c : 0, b: t.c }; }).concat([{ a: TL.c, b: bot(story) }]), T: T, W: W, sheet: sheet, end: bot(story), labs: { a: ho, b: ho + 0.12 * vh }, near: T.map(function (t) { return t.c - t.w - 1.6 * vh; }) };
    /* THE GREEN'S LIFT below 900px (jade-v2-story.css, "LEAVES WITH ITS WORDS"): from r0 the picture's foot rides --d-lk of the
       asset's height below the heading's top, one to one, until the stage lets go (rb: the story's foot meets the stage's); before r0
       a quadratic ramp of LIFT_F of the range (the keyframes' 30%) eases it off the mark. Picture box: the stage plus the crop's foot. */
    var s5 = scenes[scenes.length - 1], hd = $('.d-h2,.d-sc-big', lastBlock);
    K.lift = null;
    if (phone && s5 && hd) {
      var cs = w.getComputedStyle(s5), ar = parseFloat(cs.getPropertyValue('--d-ar')), fy = parseFloat(cs.getPropertyValue('--d-fy')), lk = parseFloat(cs.getPropertyValue('--d-lk')) || 0;
      var sh = $('#d-stage', story).offsetHeight || vh, full = Math.max(sh, ar * vw), picB = sh + (full - sh) * (1 - fy);
      var rb = bot(story) - sh, r0 = flowTop(hd) + lk * full - picB, D = rb - r0;
      if (ar > 0 && fy >= 0 && D > 1) { var ra = LIFT_F * D / (2 - LIFT_F); K.lift = { a: r0 - ra, b: rb, r1: ra, r2: D }; }
    }
    /* a true cross-dissolve at every seam (later scenes above earlier ones): the lower scene stays opaque until the upper is fully
       in, so no frame passes through the stage's ink (the dip into the cut left on 4 Oct: it read as a black flash). */
    /* PICTURES: each scene's pictures are wanted from the scroll where its dissolve begins (core's SSD.pics fetches them in that
       order with the rest of the page), held at opacity 0 until decoded, over the scene's own colours (data-d-bg, below) */
    if (S.pics) scenes.forEach(function (sc, i) { if (i && T[i - 1]) $$('img', sc).forEach(function (im) { S.pics.at(im, T[i - 1].c - T[i - 1].w, { gate: 1 }); }); });
    if (SDA) {
      var far = K.end + 9 * vh;
      scenes.forEach(function (sc, i) {
        var a = T[i - 1], o = T[i], tw = a ? a.c - a.w : 0;
        setV(sc, '--d-la', K.life[i].a); setV(sc, '--d-lb', K.life[i].b);
        setV(sc, '--d-wa', Math.max(1, tw - WARM * vh)); setV(sc, '--d-ia', tw); setV(sc, '--d-ib', a ? a.c + a.w : 0);
        setV(sc, '--d-oa', o ? o.c - o.w : far); setV(sc, '--d-ob', o ? o.c + o.w : far + 1);
      });
      if (s5) { var L = K.lift || { a: far, b: far + 1, r1: 0, r2: 0 }; setV(s5, '--d-ra', L.a); setV(s5, '--d-rb', L.b); setV(s5, '--d-r1', L.r1); setV(s5, '--d-r2', L.r2); }
      h.classList.add('d-sda');
    }
  }
  function opac(y) {
    var T = K.T, p = [], o = [], i;
    for (i = 0; i < T.length; i++) p[i] = ss((y - (T[i].c - T[i].w)) / (2 * T[i].w));
    /* NATIVE: each scene's ranges in scrollY px from the same numbers: --d-la/--d-lb life (p 0 to 1), --d-wa warm-up (never at
       y 0), --d-ia/--d-ib dissolve in, --d-oa/--d-ob dissolve out (none: past the end) */
    /* scene k + 1 comes in over dissolve k; scene k stays opaque under it and leaves once it is fully covered */
    function out(k) { return p[k] >= 1 ? 0 : 1; }
    o[0] = out(0);
    for (i = 1; i < T.length; i++) o[i] = p[i - 1] * out(i);
    o[T.length] = p[T.length - 1];
    return o;
  }
  function wipeAt(y) { return ss(clamp01((y - K.W.a) / (K.W.b - K.W.a))); }
  function near(i) {
    var sc = scenes[i]; if (!sc || sc._near) return;
    sc._near = true; sc.classList.add('d-near');
    $$('img', sc).forEach(function (im) { if (im.decode) { var go = function () { im.decode().catch(function () {}); }; if (im.complete) go(); else im.addEventListener('load', go, { once: true }); } });
  }
  function applyStage(y) {
    var o = opac(y), i;
    /* y > 0: at the top only the hero loads (scene 1 on first scroll or after load, see arm()) */
    for (i = 1; i < scenes.length; i++) if ((y > 0 && y >= K.near[i - 1]) || (armed && i === 1)) near(i);
    /* NATIVE: the browser runs opacity, visibility and pushes; warm-up and dissolves sit after K.near, so near() is all a frame does */
    if (SDA) return;
    for (i = 0; i < scenes.length; i++) {
      var sc = scenes[i], v = Math.round(o[i] * 1000) / 1000;
      /* WARM-UP: the incoming scene is shown at opacity .001 and promoted a viewport ahead of its dissolve, so it is decoded and
         rastered while nothing moves. */
      var warm = false;
      /* y > 0: never warm on first paint (it became the phone LCP: 0.97 -> 2.0 s) */
      if (i > 0 && v === 0 && y > 0 && K.T[i - 1]) { var tw = K.T[i - 1].c - K.T[i - 1].w; warm = y >= tw - WARM * vh && y < tw; }
      if ((v > 0 || warm) && !sc._near && i) near(i);
      if (warm) v = 0.001;
      if (sc._o !== v) { sc._o = v; sc.style.opacity = v; }
      var vis = v > 0 ? 'visible' : 'hidden';
      if (sc._v !== vis) { sc._v = vis; sc.style.visibility = vis; }
      if (v > 0 && sc.hasAttribute('data-d-push')) { var L = K.life[i], pr = Math.round(clamp01((y - L.a) / (L.b - L.a)) * 1000) / 1000; if (sc._p !== pr) { sc._p = pr; sc.style.setProperty('--p', pr); } }
      var wc = v > 0 ? 'opacity' : 'auto';
      if (sc._wc !== wc) { sc._wc = wc; sc.style.willChange = wc; }
    }
    /* the green's lift (fallback): the same curve as @keyframes d-lift */
    if (K.lift) { var Lf = K.lift, u = Math.min(y, Lf.b) - Lf.a, rr = Lf.r1; setV(scenes[scenes.length - 1], '--d-ry', u <= 0 ? 0 : u < 2 * rr ? u * u / (4 * rr) : u - rr); }
    var p = Math.round(wipeAt(y) * 1000) / 1000;
    if (win && p !== win._p) {
      win._p = p; var x = (1 - p) * 100;
      win.style.transform = 'translate3d(' + x + '%,0,0)'; winB.style.transform = 'translate3d(' + (-x) + '%,0,0)';
      win.style.visibility = p > 0 ? 'inherit' : 'hidden';
      var wc2 = p > 0 && p < 1 ? 'transform' : 'auto'; win.style.willChange = wc2; winB.style.willChange = wc2;
    }
    var lo = Math.round((1 - clamp01((y - K.labs.a) / (K.labs.b - K.labs.a))) * 100) / 100;
    if (lo !== labsO) { labsO = lo; labs.forEach(function (l) { l.style.opacity = lo; }); }
  }

  /* the spine: one gold hairline from the hero to the last button, notched at every chapter; 1px divs revealed by scaleY; it never
     retracts; at CHOOSE's button the ring draws once. Lives in <body> ("jv2 d-spine", z-index 2), under the theme header. */
  var spine = null, TK = 0.62;
  function buildSpine() {
    TK = phone ? 0.7 : 0.62;
    var sx = measureSvh();
    if (!spine) { spine = d.createElement('div'); spine.className = 'jv2 d-spine'; spine.setAttribute('aria-hidden', 'true'); d.body.appendChild(spine); }
    spine.textContent = '';
    var btn = $('#d-atc-choose'), eye = $('.d-buy-eye'), buy = $('.d-buy'), hand = $('.d-handoff'), hero = $('.d-hero');
    if (!btn || !eye || !buy || !hand || !hero) return;
    var start = phone ? top(eye) + 2 : top(buy) + 30;
    var br = btn.getBoundingClientRect(), bt = br.top + w.scrollY, end = bt + br.height / 2;
    var handMid = top(hand) + hand.offsetHeight * 0.55;
    var zones = phone ? [[start, bot(hero) - 0.2 * svh, 'gold-ink'], [bot(hero) - 0.2 * svh, handMid, 'gold'], [handMid, end, 'gold-ink']]
                      : [[start, handMid, 'gold'], [handMid, end, 'gold-ink']];
    var segs = [];
    /* NATIVE: each segment twice in one place: a scroll-driven twin (.d-sd) grows with the tip; the JS one holds the high-water
       mark, written only when the visitor turns back up, so the line never retracts */
    zones.forEach(function (z) {
      if (z[1] <= z[0]) return;
      var css = 'left:' + sx + 'px;top:' + Math.round(z[0]) + 'px;height:' + Math.round(z[1] - z[0]) + 'px;background:var(--' + z[2] + ')';
      var e = d.createElement('i'); e.className = 'd-spine-seg'; e.style.cssText = css;
      spine.appendChild(e); segs.push({ el: e, a: z[0], b: z[1], f: -1 });
      if (SDS) { var g = d.createElement('i'); g.className = 'd-spine-seg d-sd'; g.style.cssText = css; setV(g, '--d-a', z[0] - TK * vh); setV(g, '--d-b', z[1] - TK * vh); spine.appendChild(g); }
    });
    var notches = [];
    $$('[data-d-ch]').forEach(function (ch) {
      var hd = ch.querySelector('h1,h2,.d-eyebrow'), y = hd ? top(hd) + Math.min(hd.offsetHeight / 2, 26) : top(ch) + 48;
      if (y <= start + 4 || y >= end - 8) return;
      var col = 'gold-ink'; zones.forEach(function (z) { if (y >= z[0] && y < z[1]) col = z[2]; });
      var n = d.createElement('i'); n.className = 'd-notch';
      n.style.cssText = 'left:' + sx + 'px;top:' + Math.round(y) + 'px;background:var(--' + col + ')';
      spine.appendChild(n); notches.push({ el: n, y: y });
    });
    notches.sort(function (a, b) { return a.y - b.y; });
    /* the ring: spine to button, then once around it */
    var pad = phone ? 9 : 12, r = 4 + pad, L = br.left - pad, R = br.right + pad, Tt = bt - pad, B = bt + br.height + pad, cy = end;
    var ox = sx, oy = Tt - 2, Wd = R - ox + 4, Ht = B - Tt + 4;
    function X(v) { return (v - ox).toFixed(1); } function Y(v) { return (v - oy).toFixed(1); }
    var dd = 'M' + X(sx) + ' ' + Y(cy) + 'H' + X(L) + 'V' + Y(Tt + r) + 'Q' + X(L) + ' ' + Y(Tt) + ' ' + X(L + r) + ' ' + Y(Tt) +
      'H' + X(R - r) + 'Q' + X(R) + ' ' + Y(Tt) + ' ' + X(R) + ' ' + Y(Tt + r) + 'V' + Y(B - r) + 'Q' + X(R) + ' ' + Y(B) + ' ' + X(R - r) + ' ' + Y(B) +
      'H' + X(L + r) + 'Q' + X(L) + ' ' + Y(B) + ' ' + X(L) + ' ' + Y(B - r) + 'V' + Y(cy);
    var ns = 'http://www.w3.org/2000/svg', svg = d.createElementNS(ns, 'svg'), path = d.createElementNS(ns, 'path');
    svg.setAttribute('class', 'd-ring' + (ringOn ? ' d-on' : '')); svg.setAttribute('width', Math.ceil(Wd)); svg.setAttribute('height', Math.ceil(Ht));
    svg.setAttribute('viewBox', '0 0 ' + Math.ceil(Wd) + ' ' + Math.ceil(Ht)); svg.style.left = ox + 'px'; svg.style.top = oy + 'px';
    path.setAttribute('d', dd); path.setAttribute('pathLength', '1'); svg.appendChild(path); spine.appendChild(svg);
    SP = { segs: segs, notches: notches, end: end, ring: svg, start: start };
    ni = 0;
    applySpine(w.scrollY, true);
  }
  function applySpine(y, force) {
    if (!SP) return;
    var tip = S.reduced ? Infinity : y + TK * vh, up = y < spY; spY = y;
    if (tip > drawn) drawn = tip; else if (!force && !(SDS && up)) return;
    if (!SDS || force || up) SP.segs.forEach(function (s) {
      var f = Math.round(clamp01((drawn - s.a) / (s.b - s.a)) * 4000) / 4000;
      if (f !== s.f) { s.f = f; s.el.style.transform = 'scaleY(' + f + ')'; }
    });
    while (ni < SP.notches.length && SP.notches[ni].y <= drawn) { SP.notches[ni].el.classList.add('d-on'); ni++; }
    if (drawn >= SP.end) {
      if (!SP.ring.classList.contains('d-on')) SP.ring.classList.add('d-on');
      if (!ringOn) { ringOn = true; var slot = $('.d-ring-slot'); if (slot) slot.classList.add('d-ring-on'); }
    }
  }

  /* ───────── the frame ───────── */
  /* SCROLL COST (4 Oct, 390px / 4x CPU): reading scrollY in a rAF forces the frame's style recalc early, and a scroll-driven
     page recalculates every frame, so this read cost 96-206 ms per 10 s of scrolling while the story itself wrote nothing.
     With scroll-driven animations (SD) nothing here draws per frame: the read moves to the task right after the frame has
     painted (layout clean, so free), at most once per frame, and stops entirely once everything it can do is done
     (every scene warmed, the spine drawn to the button, the ring on). Without SD (the fallback) the stage is written in the
     rAF as before, but only while the story is on screen: past its foot every value is clamped, so it is written once at
     the foot and the loop sleeps until the story comes back (IntersectionObserver), or for good once the spine is done. */
  var lastYs = -1, lateQ = false, idle = false, storyIn = true;
  function frame() {
    ticking = false;
    var y = w.scrollY; if (y === lastY) return; lastY = y;
    if (stageOn && K) { var ys = Math.min(y, K.end); if (ys !== lastYs) { lastYs = ys; applyStage(ys); } }
    applySpine(y);
    idle = settled();
  }
  /* nothing left for a frame to do: every scene near, the spine drawn to the button with its JS half at full length, every notch
     and the ring on (the JS half is written on the way back up, so a reader who only scrolls down keeps the cheap late read) */
  function settled() {
    if (!SP || drawn < SP.end || ni < SP.notches.length || !ringOn) return false;
    for (var i = 0; i < SP.segs.length; i++) if (SP.segs[i].f !== 1) return false;
    if (stageOn && K) { if (!SD && lastYs < K.end) return false; for (i = 1; i < scenes.length; i++) if (!scenes[i]._near) return false; }
    return true;
  }
  function kick() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  function late() { lateQ = false; frame(); }
  w.addEventListener('scroll', function () {
    if (!armed) arm();
    if (idle) return;
    if (SD) { if (!lateQ) { lateQ = true; setTimeout(late, 0); } }
    else if (storyIn || !SP || drawn < SP.end || ni < SP.notches.length) kick();
  }, { passive: true });
  if (!SD && 'IntersectionObserver' in w) new IntersectionObserver(function (es) { storyIn = es[es.length - 1].isIntersecting; idle = false; kick(); }).observe(story);
  function arm() { armed = true; if (stageOn && K) near(1); }

  /* a scene's placeholder: its picture's own colours, top to bottom (data-d-bg="landscape|portrait|portrait media"), so a picture
     still on its way shows its tones instead of the stage's ink */
  function tones() {
    scenes.forEach(function (sc) { var g = sc.getAttribute('data-d-bg'); if (g) { g = g.split('|'); sc.style.background = 'linear-gradient(' + (g[2] && w.matchMedia(g[2]).matches ? g[1] : g[0]) + ')'; } });
  }
  function rebuild() {
    vh = w.innerHeight; vw = w.innerWidth; phone = vw < 900; tones();
    measureSvh();
    if (stageOn) buildStage();
    buildSpine();
    storyTop = top(story);
    lastY = -1; lastYs = -1; idle = false; frame();
  }
  var rt = 0, rt2 = 0;
  w.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { if (w.innerWidth !== vw || Math.abs(w.innerHeight - vh) > 140) rebuild(); }, 160);
  });
  S.onReady(function () {
    /* CHOOSE row follows the tier (1, 2 or 5 bottles; transform/opacity only). The caption is the tier's own label before " · ". */
    var row = $('#d-row'), cap = $('#d-row-cap');
    S.tier.on(function (n, info) {
      if (row) row.setAttribute('data-count', String(n));
      if (cap && info && info.label) cap.textContent = String(info.label).split(' · ')[0];
    });
    function afterLoad() {
      setTimeout(function () { if (!armed) arm(); }, 2500);
      rebuild();
    }
    if (d.readyState === 'complete') afterLoad(); else w.addEventListener('load', afterLoad);

    rebuild();
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(rebuild);
    /* re-place on page height or header changes, never per frame */
    if ('ResizeObserver' in w) {
      var lastH = 0;
      var ro = new ResizeObserver(function () {
        var H = d.documentElement.scrollHeight, moved = Math.abs(top(story) - storyTop) >= 2;
        if (Math.abs(H - lastH) < 2 && !moved) return; lastH = H;
        clearTimeout(rt2); rt2 = setTimeout(rebuild, 180);
      });
      ro.observe($('#MainContent') || $('main') || story);
      $$('.shopify-section-group-header-group').forEach(function (g) { ro.observe(g); });
    }
  });

  /* the flow proof (QA tools): at most two stage layers painted; no text block in the middle band (25-75%) while a dissolve is in
     its middle (a layer between 0.3 and 0.7), unless the ivory sheet covers it */
  w.__dFlow = function (step) {
    if (!K) return { ok: false, why: stageOn ? 'not built' : 'stage off (reduced or watchdog)' };
    step = step || 0.02;
    var n = Math.round(1 / step), y0 = 0, y1 = Math.max(0, K.end - vh), rows = [], bad = [];
    var txt = $$('.d-sc-txt', story).map(function (e) { return [wtop(e), bot(e)]; });
    if (!phone) txt.push([top($('.d-buy')), bot($('.d-buy'))]);
    for (var i = 0; i <= n; i++) {
      var y = y0 + (y1 - y0) * i / n, o = opac(y);
      var above = 0, vis = o.filter(function (v) { return v > 0.001; }).length;
      var mid = o.some(function (v) { return v > 0.3 && v < 0.7; });
      var inMid = txt.some(function (r) { return r[1] > y + 0.25 * vh && r[0] < y + 0.75 * vh; });
      var covered = !!(K.sheet && y >= K.sheet.a && y + vh <= K.sheet.b);
      var row = { y: Math.round(y), o: o.map(function (v) { return +v.toFixed(3); }), wipe: +wipeAt(y).toFixed(3), above: above, painted: vis, dissolving: mid, textMid: inMid, covered: covered };
      rows.push(row);
      if (above > 1 || vis > 2 || (mid && inMid && !covered)) bad.push(row);
    }
    return { ok: !bad.length, steps: rows.length, vh: vh, phone: phone, T: K.T.map(function (t) { return { c: Math.round(t.c), w: Math.round(t.w), room: t.room != null ? Math.round(t.room) : null, covered: !!t.covered }; }),
      wipe: { a: Math.round(K.W.a), b: Math.round(K.W.b) }, handoff: { h: $('.d-handoff', story).offsetHeight, svh: svh }, lift: K.lift, bad: bad, rows: rows };
  };
  w.__dOpac = function (y) { return K ? { o: opac(y), wipe: wipeAt(y) } : null; };
  w.__dSpine = function () { return SP ? { start: Math.round(SP.start), end: Math.round(SP.end), drawn: Math.round(drawn), ring: SP.ring.classList.contains('d-on'), notches: SP.notches.map(function (n) { return Math.round(n.y); }), segs: SP.segs.map(function (s) { return [Math.round(s.a), Math.round(s.b), s.f]; }) } : null; };
})();
